import React, {useState,useContext } from 'react';
import {useHistory} from "react-router-dom";
import AppContext from "../../Context/AppContext";
import Header from "../../Components/Lista/HeaderCheckin";
import BlueButton from "../../Components/BlueButton";
import styled from "styled-components";


const ContainerCount=styled.div`
width:min-content;
border-radius:6px;
margin: 0 auto;
display:grid;
justify-content: center;
justify-items: center;
justify-self: center;
grid-template-columns:min-content min-content min-content;
grid-template-rows:auto;
border:1px solid rgb(217,217,217);
`;

const ButtonIncrement=styled.div`
padding:5px;
cursor:pointer;
align-self: center;
font-size:32px;
font-weight:700;
`;

const InputPartySize=styled.input`
background-color:white;
margin:5px;
width:150px;
outline: none;
border:none;
text-align:center;
font-size: 24px;
font-weight: bold;
`;

const Container=styled.div`
padding:0 20px;
margin:60px 0 0 0;
`;


const Cantidad=()=>
{
  const History=useHistory();
  const {Customer} = useContext(AppContext);
  const [Count, setCount] = useState(2);

  const handleReduce=()=>
  {
    setCount(Count-1);

    if(parseInt(Count) < 0)
    {
      setCount(1);
    } 
  }

  const handleIncrease=()=>
  {
    setCount(Count+1);

    if(parseInt(Count) >= 10)
    {
      setCount(10);
     
    } 
  }

  const Submit=()=>
  {
    Customer.count=Count;
    History.push("/lista/nombre");
  }

  return <div>
               <Header/>
               <Container>
                  <h1 style={{textAlign:"center", marginBottom:"15px"}}>Mesa para cuantas personas?</h1>

                   <ContainerCount>
                      <ButtonIncrement onClick={handleReduce} >-</ButtonIncrement> 
                      <InputPartySize disabled value={Count} type={"Number"}></InputPartySize>
                      <ButtonIncrement onClick={handleIncrease}>+</ButtonIncrement>
                    </ContainerCount>
                    <BlueButton onClick={Submit}>Continuar</BlueButton>
               </Container> 
            </div>
}

export default Cantidad
